import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';
import {NotificationService} from '../../services/notification.service';


@Component({
    selector: 'aria-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    animations: [
        trigger('fade', [
            state('fadeIn', style({opacity: 1, 'pointer-events': 'auto', transform: 'translateY(0)'})),
            transition('* => *', animate(300))
        ])
    ]
})
export class NotificationComponent {

    notification$: BehaviorSubject<{
        type: string, data: any, className?: string
    }>;


    constructor(private notificationService: NotificationService) {
        this.notification$ = this.notificationService.notification$;
    }

}
